/* eslint-disable prefer-object-spread */
import { UserService } from '@/services/user-service';
import Config from '@/config/variables';
import { i18n } from '@/i18n';
// import Vue from 'vue';

function getLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((success) => {
      console.log('success', success);
      console.log('coords', success.coords);
      console.log('long', success.coords.longitude);
      console.log('long', success.coords.latitude);
    });
  } else {
    console.log('not a new browser');
  }
}

getLocation();
export class RequestWrappers {

  static baseUrl(request) {
    const headers = Object.assign({}, request.headers);
    headers['Accept-Language'] = localStorage.getItem('lang') ? localStorage.getItem('lang').toLowerCase() : i18n.locale.toLowerCase();
    // headers['GPS-Coordinates'] = 'az';
    // headers.UserProfile = null;
    return {
      ...request,
      headers,
      baseURL: request.baseURL || Config.BaseUrl,
    };
  }

  static token(request) {
    // this.getUserLocation();
    const headers = Object.assign({}, request.headers);
    headers.Authorization = headers.Authorization || UserService.token;
    return {
      ...request,
      headers,
    };
  }
  static getUserLocation() {
    // console.log(getters.getUserData);
    // if (navigator.geolocation) {
    //   console.log(navigator.geolocation.getCurrentPosition());
    // }
    // else {
    //   x.innerHTML = "Geolocation is not supported by this browser.";
    // }
  }

}
